import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Table, Popover, Spin } from 'antd';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import moment from 'moment';//日期格式化导包
import sortImg from '../../public/img/newMain/Sort.png'
import resetImg from '../../public/img/newMain/Reset.png'
import exportImg from '../../public/img/newMain/Export.png'
import searchImg from '../../public/img/newMain/Search.png'
import { studentCheckLogin } from '../newMain/studentMain';
import WPAManagementSort from './WPAManagementSort';
import { ContextHandler } from '../../public/js/contextHandler';
import './WPAManagement.css'
import createImg from '../../public/img/newMain/Create.png';
const WPAManagement = (props) => {

    const studentModuleId = localStorage.getItem(Config.tokenPrefix + 'studentModuleId');
    const history = useHistory();
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const searchModel = useRef({});

    const [isReset, setIsReset] = useState(false);
    const [popoverVisible, setPopoverVisible] = useState(false);

    const [isLoad, setIsLoad] = useState(false);
    const [studentModuleModel, setStudentModuleModel] = useState({});

    useEffect(() => {
        if (!Config.studentInfo?.studentId) {
            studentCheckLogin();
        }
        search(10, 1)
        searchModuleById();
    }, []);

    const searchModuleById = () => {
        let model = {studentModuleId: studentModuleId};
        model.studentId = Config.studentInfo?.studentId;
        Base.callBackApi("studentModule/searchById", model).then((data) => {
            if ("SUCCESS" === data?.msg) {
                let model = data?.object ?? {};
                setStudentModuleModel(model);
            } else {
                console.log(data?.msg)
            }
        })
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew);
    }

    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1);
    }

    const searchChange = (key, value) => {
        searchModel.current = { ...searchModel.current, ...{ [key]: value } };
        search(pageSize, 1)
    }

    const search = (pageSizeNew, currentPageNew) => {
        let model = {
            ...searchModel.current, 
            studentModuleId: studentModuleId,
            studentId : Config.studentInfo?.studentId
        };
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        Base.callBackApi("wpaAppl/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                setTables(data?.object?.list ?? []);
                setTablesCount(data?.object?.total ?? 0);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                console.log("error", data.msg);
            }
        }).catch(err => { });
    }

    const reset = () => {
        searchModel.current = {};
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
        setIsReset(true)
        search(10, 1)
    }

    const handleOpenChange = (newOpen) => {
        setPopoverVisible(newOpen);
    };

    const handleOpenChangeSort = (newOpen, flag, model) => {
        setIsReset(false)
        setPopoverVisible(newOpen);
        if(flag) {
            searchModel.current = { ...searchModel.current, ...model }
            search(pageSize, 1);
        }
    };

    const tableColumns = {
        wpaApplId: "wpa_appl_id",
        companyName: "company_name",
        industrySupervisorName: "industry_supervisor_name",
        wilHours: "wil_hours",
        mark: "mark",
        applyDate: "apply_date",
        lastUpdatedDate: "last_updte_dte",
        sentToIs: "sent_to_is",
        wpaStatus: "wpa_status",
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.current.orderBy) {
            if (orderBy !== searchModel.current.orderBy) {
                searchModel.current.orderBy = orderBy;
                search(10, 1)
            }
        }
    }

    const jump = (path) => {
        history.push(path)
    }

    const jumpReview = (path, wpaApplId) => {
        localStorage.setItem(Config.tokenPrefix + 'wpaApplId', wpaApplId);
        history.push(path)
    }

    /*eslint-disable*/
    const columns = [
        {
            title: 'WPA ID',
            dataIndex: 'wpaApplId',
            width: '8%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'wpaApplId') },
        },
        {
            title: 'Company',
            dataIndex: 'companyName',
            width: '15%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'companyName') },
            render: text => (
                <Popover content={text} title="" trigger="hover">
                    <div className='tableEllipsisBox'>{text}</div>
                </Popover>
            ),
        },
        {
            title: 'Industry Supervisor',
            dataIndex: 'industrySupervisorName',
            width: '15%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'industrySupervisorName') },
            render: text => (
                <Popover content={text} title="" trigger="hover">
                    <div className='tableEllipsisBox'>{text}</div>
                </Popover>
            ),
        },
        {
            title: 'WIL Hours',
            dataIndex: 'wilHours',
            width: '10%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'wilHours') },
            render: (text) => Base.parseToFixed(text, 1),
        },
        {
            title: 'Mark',
            dataIndex: 'mark',
            width: '10%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'mark') },
            render: (text) => Base.parseToFixed(text, 1),
        },
        {
            title: 'Submit Date',
            dataIndex: 'applyDate',
            width: '13%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'applyDate') },
            render: text => text ? moment(text).format(Config.dateFormatEn) : '',
        },
        {
            title: 'Last Update',
            dataIndex: 'lastUpdatedDate',
            width: '13%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'lastUpdatedDate') },
            render: text => text ? moment(text).format(Config.dateFormatEn) : '',
        },
        {
            title: 'Sent to IS over 14 days',
            dataIndex: 'sentToIs',
            width: '16%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'sentToIs') },
        },
        {
            title: 'Status',
            dataIndex: 'wpaStatus',
            width: 180,
            sorter: (a, b) => { return Base.sortMethod(a, b, 'wpaStatus') },
            render: text => (
                <div className='tableStatusBox'>
                    <div className={'tableStatus ' + text}>{ContextHandler.getMapValue('wpaFormStatusMap', text)}</div>
                </div>
            ),
        },
        {
            title: 'Action',
            dataIndex: '',
            fixed: 'right',
            width: 80,
            render: (text, record) => (
                (record.wpaStatus == 'DRAFT' || record.wpaStatus == 'RETURNED_TO_STUDENT') ?
                    <div className='tableAction' onClick={() => jump('/student/studentFillWPA/' + record.wpaApplId)}><img src={exportImg} /></div>
                    :
                    <div className='tableAction' onClick={() => jumpReview('/student/reviewWPAFormDetail', record.wpaApplId)}><img src={exportImg} /></div>
            ),
        },
    ];
    /*eslint-enable*/

    return (
        <div id="container" className='websiteTemplate WPAManagement'>
            <Spin size="large" spinning={isLoad} >
                <div className='homeTitle'>WPA Management</div>
                <div className='moduleBox'>
                    <div className='moduleBoxCenter'>
                        <div>
                            <div className='cardSubTitle'>{studentModuleModel?.moduleCode}</div>
                            <div className='cardSubTitle'>{studentModuleModel?.moduleName}</div>
                            <div className='flexBox'>
                                <div className='label'>Student Name</div>
                                <div className='value'>{studentModuleModel?.firstName && studentModuleModel?.lastName && studentModuleModel?.firstName + ' ' + studentModuleModel?.lastName}</div>
                            </div>
                            <div className='flexBox'>
                                <div className='label'>Student ID</div>
                                <div className='value'>{studentModuleModel?.studentAcctId}</div>
                            </div>
                            <div className='flexBox'>
                                <div className='label'>Programme</div>
                                <div className='value'>{studentModuleModel?.progTitle}</div>
                            </div>
                            <div className='flexBox'>
                                <div className='label'>Cohort Year</div>
                                <div className='value'>{studentModuleModel?.cohortYear}</div>
                            </div>
                            <div className='flexBox'>
                                <div className='label'>Assigned Academic Supervisor</div>
                                <div className='value'>{studentModuleModel?.academicSupervisorUserName}</div>
                            </div>
                            <div className='flexBox'>
                                <div className='label'>Module Convener</div>
                                <div className='value'>{studentModuleModel?.moduleConvenerName}</div>
                            </div>
                            <div className='flexBox'>
                                <div className='label'>Student Record Status</div>
                                <div className='value'>{ContextHandler.getMapValue('studentModuleStatusMap', studentModuleModel?.status)}</div>
                            </div>
                        </div>
                        <div>
                            <div className='countTitleBox'>
                                <div className='cardSubTitle'>WIL Hours</div>
                            </div>
                            <div className='flexBox '>
                                <div className='label'>Total Curriculum Hours</div>
                                <div className='value '>{studentModuleModel?.curriculumHours}</div>
                            </div>
                            <div className='flexBox '>
                                <div className='label'>Other Learning Activities Hours</div>
                                <div className='value '>{studentModuleModel?.otherLearningTrainingHours}</div>
                            </div>
                            <div className='flexBox '>
                                <div className='label'>WIL Hours Exempted</div>
                                <div className='value '>{studentModuleModel?.exemptedHours}</div>
                            </div>
                            <div className='flexBox '>
                                <div className='label'>WIL Hours Needed</div>
                                <div className='value '>{studentModuleModel?.neededWilHours}</div>
                            </div>
                            <div className='flexBox '>
                                <div className='label'>WIL Hours Completed</div>
                                <div className='value '>{studentModuleModel?.completedWilHours} ({studentModuleModel?.neededWilHours > 0 ? Base.parseToPercent(studentModuleModel?.completedWilHours / studentModuleModel?.neededWilHours) : 100}%)</div>
                            </div>
                            <div className='flexBox '>
                                <div className='label'># of WPA in progress</div>
                                <div className='value '>{studentModuleModel?.inProgressWpaCount}</div>
                            </div>
                            <div className='flexBox '>
                                <div className='label'># of WPA status Sent to IP that is over 14 days</div>
                                <div className='value '>{studentModuleModel?.sentToIsCount}</div>
                            </div>
                            <div className='flexBox '>
                                <div className='label'># of WPA Completed</div>
                                <div className='value '>{studentModuleModel?.completedWpaCount}</div>
                            </div>
                        </div>
                        <div>
                            <div className='countTitleBox'>
                                <div className='cardSubTitle'>Assignments</div>
                            </div>
                            <div className='flexBox '>
                                <div className='label'># of Assignments submitted vs. target</div>
                                <div className='value '>{studentModuleModel?.studentModuleAssignModelList ? studentModuleModel?.studentModuleAssignModelList?.filter(item => item.status == 'SUBMITTED')?.length + '/' + studentModuleModel?.studentModuleAssignModelList?.length : '0/0'}</div>
                            </div>
                            <div className='countTitleBox'>
                                <div className='cardSubTitle'>Marks</div>
                            </div>
                            {studentModuleModel?.studentModuleAssignModelList?.map(item =>
                                <div className='flexBox ' key={item?.studentModuleAssignId}>
                                    <div className='label'>{item?.assignName} mark</div>
                                    <div className='value '>{item?.assignMarks == 0 ? '0/100' : (item?.assignMarks ? Base.parseToFixed(item?.assignMarks, 2) + '/100' : 'Incomplete')}</div>
                                </div>
                            )}
                            <div className='flexBox '>
                                <div className='label'>Total WPA mark</div>
                                <div className='value '>{studentModuleModel?.wpaMarks == 0 ? '0/100' : (studentModuleModel?.wpaMarks ? Base.parseToFixed(studentModuleModel?.wpaMarks, 2) + '/100'  : 'N/A')}</div>
                            </div>
                            <div className='flexBox '>
                                <div className='label'>Total Module Mark and grade</div>
                                <div className='value '>{studentModuleModel?.totalModuleMark == 0 ? '0/100' : (studentModuleModel?.totalModuleMark ? Base.parseToFixed(studentModuleModel?.totalModuleMark, 2) + '/100 (' + Base.calcGrade(studentModuleModel?.totalModuleMark) + ')' : 'N/A')} </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='websiteSysSearchRow'>
                    <div className='websiteSysSearchBar'>
                        <input style={{ paddingLeft: '11px' }} placeholder="Search by Company, Industry Supervisor" value={searchModel.current.companyName || ''}
                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1) : null}
                            onChange={(e) => searchChange('companyName', e.target.value)} />
                        <img src={searchImg} onClick={() => search(pageSize, 1)} />
                    </div>
                    <Popover placement="topRight" trigger="click" open={popoverVisible}
                        onOpenChange={handleOpenChange} content={
                            <WPAManagementSort isReset={isReset} onOpenChange={handleOpenChangeSort} />
                        }
                        getPopupContainer={() => document.getElementById('sortButton')}
                    >
                        <div className='websiteSysButton sortButton' id='sortButton'><img src={sortImg} />Sort</div>
                    </Popover>
                    <div className='websiteSysButton sortButton' onClick={reset}><img src={resetImg} />Reset</div>
                    <div className='websiteSysButton' onClick={() => jump('/student/studentFillWPA')}><img src={createImg} />New WPA Form</div>
                </div>

                <div className="sysTable" id="tableOne" style={{ marginTop: '20px' }} >
                    <Table
                        scroll={{ x: 1200 }}
                        rowKey="wpaApplId"
                        columns={columns} //列名
                        dataSource={tables} //数据
                        pagination={{  //分页
                            showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                            onChange: onChange,            //上页下页或者跳页方法
                            onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                            total: tablesCount,             //总共多少条数据
                            current: current,         //当前页
                            pageSize: pageSize,       //每页显示多少条数据
                            defaultCurrent: 1,                               //默认当前页为1
                            size: "small"
                        }}
                        onChange={handleTableChange}
                    />
                </div>
            </Spin>
        </div>
    )

}

export default WPAManagement;